module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he source of the Bowman Papers is Glasgow University Archive, and I would very much like to highlight the efficiency and courtesy of the archive staff. Additional material comes from the Seeley G. Mudd Manuscript Library branch of Princeton University Library, from the Mitchell Library Glasgow, from Edinburgh University Archive and from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bundesarchiv-Bildarchiv")]), _vm._v(" Koblenz.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am very grateful for the support of A.A. Bowman’s grandchildren, Marjorie Stewart, Janet Macfie, Lydia Bowman and Alastair Gillespie, all of whom shared photographs and documents with me. In addition, Marjorie has written the Afterword.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I also wish to thank A.A. Bowman’s niece, Virginia Crawford, for memories of her early years in Princeton and Glasgow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would also like to thank Colonel Bobby Steele, TD "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary#gloss4",
      "id": "rgloss4"
    }
  }, [_vm._v("DL")]), _vm._v(" for making available the records in the Royal Highland Fusiliers Museum (the "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary#gloss14",
      "id": "rgloss14"
    }
  }, [_vm._v("RHF")]), _vm._v(" is the successor regiment to the HLI and the Royal Scots Fusiliers).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, my thanks to Joseph Russo, PhD candidate in German, School of Modern Languages & Cultures University of Glasgow, for translating from the German; and to India Fullarton, Photographic Unit University of Glasgow, for photography.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42dcf4fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Acknowledgements.vue
// module id = 72
// module chunks = 0